import { render, staticRenderFns } from "./chirp-form-new.vue?vue&type=template&id=4c6c5fde&scoped=true&"
import script from "./chirp-form-new.vue?vue&type=script&lang=js&"
export * from "./chirp-form-new.vue?vue&type=script&lang=js&"
import style0 from "./chirp-form-new.vue?vue&type=style&index=0&id=4c6c5fde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c5fde",
  null
  
)

export default component.exports